<template>
  <div class="paid-custody-cancel">
    <NavBar sticky>
      <template #left>
        <BackButton />
      </template>
    </NavBar>

    <div class="paid-custody-cancel__container">
      <HelperViewStatus
        title="Quer desativar a custódia remunerada?"
        description="Se você tiver ativos alugados, eles estarão disponíveis para você em até três dias úteis."
        status="alert"
      />
    </div>

    <footer class="paid-custody-cancel__footer">
      <ButtonContainer>
        <template #button-primary>
          <ButtonSecondary
            label="Desativar custódia remunerada"
            @click="handleNextClick"
          />
        </template>
      </ButtonContainer>
    </footer>

    <ModalPassword
      :loading-password="loadingPassword"
      :is-open="showModalPassword"
      @close="handleCloseModalPassword"
      @confirm="handleConfirmPassword"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  ButtonContainer,
  ButtonSecondary,
  HelperViewStatus,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ref } from 'vue';
import { ModalPassword } from '../ModalPassword';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { canceledPaidCustody } from '@/modules/trade/services/paid-custody';

const router = useRouter();
const showModalPassword = ref(false);
const loadingPassword = ref(false);

const handleNextClick = () => {
  showModalPassword.value = true;
};

const handleCloseModalPassword = () => {
  showModalPassword.value = false;
};

const handleConfirmPassword = async () => {
  try {
    loadingPassword.value = true;
    const response = await canceledPaidCustody();

    router.replace({ name: 'trade' });

    if (response.message) {
      return notify({
        group: 'wrn-notifications',
        text: response.message,
        type: NotificationTypes.success
      });
    } else {
      return notify({
        group: 'wrn-notifications',
        text: 'Custódia remunerada desativada.',
        type: NotificationTypes.success
      });
    }
  } catch (e) {
    router.replace({ name: 'trade' });

    return notify({
      group: 'wrn-notifications',
      text: 'Não foi possível cancelar a custódia remunerada, tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    loadingPassword.value = false;
  }
};
</script>

<style lang="less" scoped>
.paid-custody-cancel {
  &__container {
    height: calc(100vh - @size-spacing-x1200);
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: @size-spacing-x1200;

    :deep(.helper-status) {
      max-width: 406px;
    }

    :deep(.helper-view__icon) {
      height: 48px;
      width: 48px;
    }

    :deep(.initial-avatar-icon) {
      height: 48px;
      width: 48px;
    }

    :deep(.helper-view__title p) {
      font-size: 40px;
      line-height: 48px;
      font-weight: 400;
    }
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: @background-secondary;
  }
}
</style>
